import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, MessageCircle, FileText, User, Clipboard } from "lucide-react";
import "./BottomNavigation.css";

const BottomNavigationParent = () => {
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isVisible, setIsVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(window.scrollY);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        const handleScroll = () => {
            if (window.scrollY > lastScrollY) {
                setIsVisible(false); // Hide when scrolling down
            } else {
                setIsVisible(true); // Show when scrolling up
            }
            setLastScrollY(window.scrollY);
        };

        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, [lastScrollY]);

    if (!isMobile) return null; // Hide on larger screens

    return (
        <div className={`bottom-nav ${isVisible ? "visible" : "hidden"}`}>
            <Link to="/" className={`nav-item-mobile ${location.pathname === "/parent/dashboard" ? "active" : ""}`}>
                <Home size={24} />
                <span>Home</span>
            </Link>
            <Link to="/staff/projectsandtasks/tasks" className={`nav-item-mobile ${location.pathname === "/admin/profile" ? "active" : ""}`}>
                <Clipboard size={24} />
                <span>Tasks</span>
            </Link>
            <Link to="/parent/chat" className={`nav-item-mobile ${location.pathname === "/parent/chat" ? "active" : ""}`}>
                <MessageCircle size={24} />
                <span>Chat</span>
            </Link>
            <Link to="/staff/projectsandtasks/projects" className={`nav-item-mobile ${location.pathname === "/parent/exams" ? "active" : ""}`}>
                <FileText size={24} />
                <span>Projects</span>
            </Link>
            <Link to="/staff/profile" className={`nav-item-mobile ${location.pathname === "/parent/profile" ? "active" : ""}`}>
                <User size={24} />
                <span>Profile</span>
            </Link>
        </div>
    );
};

export default BottomNavigationParent;
